import {MaterialConnection} from "#material/nodes/base/connection/material-connection"
import type {MaterialNode} from "#material/nodes/base/material/material-node"
import {materialNodeSchema} from "#material/nodes/base/material/schema"
import type {GraphNodeDefinition} from "@cm/graph-v3"
import {graphNode} from "@cm/graph-v3"
import {z} from "zod/v4-mini"
import type {Three as THREE} from "#material/three/exports"
import type {MaterialOutputNode} from "#material/cycles/types"

export type MaterialGraphParameters = {
    connections: MaterialConnection<any>[]
    name?: string
    editor?: {
        center: {
            x: number
            y: number
        }
        scale: number
    }
    materialId?: string
    materialLegacyId?: number
    materialRevisionLegacyId?: number
    nodes: MaterialNode<any>[]
}

export type MaterialGraphThreeReturns = THREE.Material
export type MaterialGraphCyclesReturns = MaterialOutputNode

export const materialGraphDefinition = {
    nodeClass: "MaterialGraph",
    validation: {
        returns: z.any(),
        parameters: z.strictObject({
            connections: z.array(graphNode(MaterialConnection)),
            editor: z.optional(
                z.strictObject({
                    center: z.strictObject({
                        x: z.number(),
                        y: z.number(),
                    }),
                    scale: z.number(),
                }),
            ),
            materialId: z.optional(z.string()),
            materialLegacyId: z.optional(z.number()),
            materialRevisionLegacyId: z.optional(z.number()),
            name: z.optional(z.string()),
            nodes: z.array(materialNodeSchema),
        }),
    },
} satisfies GraphNodeDefinition<MaterialGraphThreeReturns | MaterialGraphCyclesReturns, MaterialGraphParameters>
